module.exports = __webpack_public_path__ + "static/media/product-3d-desktop.982fbabd.gif";